import {Navigate, Route} from "react-router";
import {RequireAuth} from "~/authentication/routing/RequireAuth";
import {TaxonomyBuilderLayout} from "~/pages/taxonomy-builder-v2/TaxonomyBuilderLayout";
import {TaxonomyBuilderPage} from "~/pages/taxonomy-builder-v2/TaxonomyBuilderPage";
import {AllCategoriesTab} from "~/pages/taxonomy-builder-v2/tabs/AllCategories/AllCategoriesTab";
// Not in this version.
// import {SuggestionsTab} from "~/pages/taxonomy-builder-v2/tabs/Suggestions/SuggestionsTab";
// import {HealthFindingsTab} from "~/pages/taxonomy-builder-v2/tabs/HealthFindings/HealthFindingsTab";
import {TaxonomyApprovalLayout} from "~/pages/taxonomy-builder-v2/approval/TaxonomyApprovalLayout";
import {TaxonomyApprovalPage} from "~/pages/taxonomy-builder-v2/approval/TaxonomyApprovalPage";
import {routes} from "./routes";

export const taxonomyBuilderRoute = (
    <Route path={routes.cleanup_taxonomy_builder} element={<RequireAuth><TaxonomyBuilderLayout/></RequireAuth>}>
        <Route element={<TaxonomyBuilderPage/>}>
            {/* No tab segment, or an unrecognized one, both redirect to all categories. */}
            <Route index element={<Navigate to="all" replace/>}/>
            <Route path="all" element={<AllCategoriesTab/>}/>
            {/* Not in this version: these paths now redirect to all categories. */}
            {/* <Route path="suggestions" element={<SuggestionsTab/>}/> */}
            {/* <Route path="findings" element={<HealthFindingsTab/>}/> */}
            <Route path="*" element={<Navigate to="../all" replace/>}/>
        </Route>
    </Route>
);

/** The review of a taxonomy approval request. */
export const taxonomyApprovalRoute = (
    <Route path={routes.approval_tax_detail} element={<RequireAuth><TaxonomyApprovalLayout/></RequireAuth>}>
        <Route index element={<TaxonomyApprovalPage/>}/>
    </Route>
);
